<div class="main-container">
    <div class="top-menu">
        <div>
            <p-menubar [model]="topMenuItems"></p-menubar>
        </div>
        <div>
            <div class="filter-option-container">
                <p-button label="Filter" (onClick)="filterInvoices()" icon="pi pi-filter"></p-button>
                <p-button label="Clear filters" (onClick)="clearFilters()" icon="pi pi-filter-slash"></p-button>
            </div>
            <div [formGroup]="filterForm" class="filter-form">
                <div class="date-conditions-container">
                    <span>Date: </span>
                    <div class="date-options-container">
                        <div>
                            <span>At: </span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateAt"
                                (onSelect)="filterBySingleDate()"></p-calendar>
                        </div>
                        <div>
                            <span>From</span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateFrom"
                                (onSelect)="filterByDateRange()"></p-calendar>
                            <span>To</span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateTo"
                                (onSelect)="filterByDateRange()"></p-calendar>
                        </div>
                    </div>

                </div>

                <div>
                    <span>Amount: </span>
                    <span>min:</span>
                    <p-inputNumber mode="decimal" minFractionDigits="2" maxFractionDigits="2" locale="fr-FR"
                        formControlName="minAmount"></p-inputNumber>
                    <span>max:</span>
                    <p-inputNumber mode="decimal" minFractionDigits="2" maxFractionDigits="2" locale="fr-FR"
                        formControlName="maxAmount"></p-inputNumber>
                </div>
                <div>
                    <span>Supplier company</span>
                    <p-dropdown [options]="suppliers" formControlName="supplier" optionLabel="name"
                        placeholder="Select" />
                </div>
            </div>


        </div>
    </div>
    <div>
        <p-table [value]="filteredInvoices" [showLoader]="true" styleClass="p-datatable-striped" (sortFunction)="customSort($event)">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="id">
                        ID <p-sortIcon field="id" />
                    </th>
                    <th pSortableColumn="invoiceNumber">
                        Inv. number <p-sortIcon field="invoiceNumber" />
                    </th>
                    <th pSortableColumn="supplier.name">
                        Supplier<p-sortIcon field="supplier.name" />
                    </th>
                    <th pSortableColumn="date">
                        Date
                        <p-sortIcon field="date" />
                    </th>
                    <th pSortableColumn="amount" width="120">
                        Amount
                        <p-sortIcon field="amount" />
                    </th>
                    <th>
                        Encoded by
                    </th>
                    <th width="200">
                        File
                    </th>
                    <th>
                        Action
                    </th>
                    <th>
                        Edit
                    </th>
                    <th>
                        Validated
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
                <tr>
                    <td>
                        <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                            {{invoice.id}}
                        </p>
                    </td>
                    <td>
                        <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                            {{invoice.invoiceNumber}}
                        </p>
                    </td>
                    <td>
                        <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                            {{invoice.supplier.name}}
                        </p>
                    </td>
                    <td>
                        <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                            {{invoice.date | date:'dd/MM/yyyy'}}
                        </p>
                    </td>
                    <td>
                        {{invoice.amount}}
                    </td>
                    <td>
                        <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                            {{invoice.createdBy.name}}
                        </p>
                    </td>
                    <td>
                        <div class="file-menu-container">
                            <p-button (onClick)="downloadPdfFile(invoice.id, invoice.fileName, invoice.isValidated)"
                                icon="pi pi-file-pdf"></p-button>
                            <p [ngClass]="{'not-validated': !invoice.isValidated, 'validated': invoice.isValidated}">
                                {{invoice.fileName}}
                            </p>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!invoice.isPaid">
                            <p-button label="Mark as paid" (onClick)="markAsPaid(invoice)"></p-button>
                        </div>
                    </td>
                    <td>
                        <p-button icon="pi pi-file-edit" (onClick)="openEditWindow(invoice.id)"></p-button>
                    </td>
                    <td>
                        <div *ngIf="invoice.isValidated">
                            <i class="pi pi-check"></i>
                            <span class="validated">Validated</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>